import React from "react";
import { FaEdit } from "react-icons/fa";
import EditPersonalDetails from "./EditPersonalDetails";
import Skeleton from "react-loading-skeleton";

const PersonalDetails = ({ userProfile, isLoading, refetch }) => {
  return (
    <>
      <div className="d-flex justify-content-between mb-2">
        <h4 className="small-text font-weight-bold">Personal Details:</h4>
        <button
          className="btn btn-outline-primary btn-edit-user-profile"
          data-toggle="modal"
          data-target="#editPersonalDetails"
        >
          <FaEdit size={16} className="mr-2" /> Edit
        </button>
        <EditPersonalDetails
          userProfile={userProfile}
          isLoading={isLoading}
          refetch={refetch}
        />
      </div>
      <div className="row small-text">
        <div className="col-md-6">
          <div className="row">
            <div className="col-md-3">
              <p>First Name:</p>
            </div>
            <div className="col-md-6">
              <p className="font-weight-bold">
                {userProfile?.firstName
                  ? userProfile?.firstName
                  : isLoading && <Skeleton width={100} height={20} />}
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <p>Middle Name:</p>
            </div>
            <div className="col-md-6">
              <p className="font-weight-bold">
                {userProfile?.middleName
                  ? userProfile?.middleName
                  : isLoading && <Skeleton width={100} height={20} />}
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <p>Last Name:</p>
            </div>
            <div className="col-md-6">
              <p className="font-weight-bold">
                {userProfile?.lastName
                  ? userProfile?.lastName
                  : isLoading && <Skeleton width={100} height={20} />}
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <p>Ethnicity:</p>
            </div>
            <div className="col-md-6">
              <p className="font-weight-bold">
                {userProfile?.ethnicity
                  ? userProfile?.ethnicity
                  : isLoading && <Skeleton width={100} height={20} />}
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="row">
            <div className="col-md-4">
              <p>Biological Sex: <span style={{ color: '#8e3039' }}>*</span></p>
            </div>
            <div className="col-md-6">
              <p className="font-weight-bold">
                {userProfile?.sex
                  ? userProfile?.sex
                  : isLoading && <Skeleton width={100} height={20} />}
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <p>Gender Identification:</p>
            </div>
            <div className="col-md-6">
              <p className="font-weight-bold">
                {userProfile?.gender
                  ? userProfile?.gender
                  : isLoading && <Skeleton width={100} height={20} />}
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <p>Date of Birth: <span style={{ color: '#8e3039' }}>*</span></p>
            </div>
            <div className="col-md-6">
              <p className="font-weight-bold">
                {userProfile?.dateOfBirth
                  ? userProfile?.dateOfBirth
                  : isLoading && <Skeleton width={100} height={20} />}
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <p>Language Preference: <span style={{ color: '#8e3039' }}>*</span></p>
            </div>
            <div className="col-md-6">
              <p className="font-weight-bold">
                {userProfile?.languagePreference
                  ? userProfile?.languagePreference
                  : isLoading && <Skeleton width={100} height={20} />}
              </p>
            </div>
          </div>
        </div>
      </div>
      <hr />
    </>
  );
};

export default PersonalDetails;
